import { Component, Inject, OnInit } from '@angular/core';
import { FileReaderEvent } from '../../../../app/shared/models/FileReader';
import { ModelBaseObservations } from '../setup-models.model';
import { NotificationsService } from 'angular2-notifications';
import { DomSanitizer } from '@angular/platform-browser';
import { SetupModelsService } from '../setup-models.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-obspoints-update-limits',
  templateUrl: './obspoints-update-limits.component.html',
  styleUrls: ['./obspoints-update-limits.component.scss']
})
export class ObspointsUpdateLimitsComponent implements OnInit {

  Title:string;
  TooolImage:string
  min:number;
  max:number;

  observationInfo:ModelBaseObservations;
  constructor(     
    private _dialog: MatDialog,
    public dialogRef: MatDialogRef<ObspointsUpdateLimitsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _modelService: SetupModelsService,
    private _sanitizer: DomSanitizer,
    private _notification: NotificationsService,) { 
    
  }

  ngOnInit() {

    this.observationInfo = this.data.observationInfo;
  }

  // onSelectObsPhoto(event) {
  //   if (event.target.files && event.target.files[0]) {
  //     const reader = new FileReader();

  //     reader.readAsDataURL(event.target.files[0]); // read file as data url
  //     reader.onload = (event: FileReaderEvent) => { // called once readAsDataURL is completed
  //       const imageUrl = (event.target.result);
  //       this.compressImage(imageUrl).then((res: string) => {
  //         // console.log("imageUrl", res)
  //         if (res) {
  //          //console.log('res', res)

  //           //photo.NewPhoto =  this.uploadPhoto(res.split(',')[1]);
  //           this.observationInfo.ToolImage = res.split(',')[1];
  //         }
  //       })
  //     };
  //   }
  // }
  onSelectObsPhoto(event: any) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
  
      reader.readAsDataURL(event.target.files[0]); // read file as data URL
  
      reader.onload = (event: ProgressEvent<FileReader>) => { // called once readAsDataURL is completed
        if (event.target && event.target.result) {
          const imageUrl = event.target.result as string; // Cast result to string
  
          this.compressImage(imageUrl).then((res: string) => {
            if (res) {
              // Assign the base64-encoded image data (after the comma) to ToolImage
              this.observationInfo.ToolImage = res.split(',')[1];
            }
          });
        }
      };
    }
  }
  
  compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();




      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');

        let width, height;
        width = img.width;
        height = img.height;

        console.log('width', width)
        console.log('height', height)

        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800;//643
        var new_height = imageWidth * ratio; //calculate new height


        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }


  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' +image);
  }

  Update(){
    //
    this._modelService.UpdateModelObsInfo(this.observationInfo).subscribe(result => {
      if(result==true){
        this.dialogRef.close(true);
      }else{
        this.dialogRef.close(false);

      }
    });
  }
  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
